import React from 'react';
import { Slide } from '../../components/deck/Slide';
import { Eyebrow, INK, Label, Reveal, Title } from '../../components/deck/Type';
const groups = [{
  name: 'Documents',
  tone: INK.blue,
  items: ['Investment memos', 'IC templates', 'Diligence reports', 'Company profiles']
}, {
  name: 'Frameworks',
  tone: INK.violet,
  items: ['Scoring models', 'Research templates', 'Market maps', 'Technology assessments']
}, {
  name: 'Data & models',
  tone: INK.emerald,
  items: ['Financial models', 'Document uploads', 'Data rooms']
}];
export function IndustryAssetsSlide() {
  return <Slide data-id="element-248" data-mp="xf8fof1yjnr6">
      <Eyebrow data-id="element-249" data-mp="xg0avorn7jgx">Industry-native assets</Eyebrow>
      <Title className="mt-[2.2cqh] max-w-[70%]" data-id="element-250" data-mp="sfm03yynpvf7">
        Professionals don&apos;t work from prompts. They work from processes.
      </Title>

      <div className="mt-auto grid h-[52cqh] grid-cols-[28%_1fr] gap-[1.6cqw]" data-id="element-251" data-mp="28saylgrj4pei">
        <div className="flex flex-col border border-white/10 bg-white/[0.02] p-[1.8cqw]" data-id="element-252" data-mp="23tg2jd4jx4cg">
          <Label data-id="element-253" data-mp="25v04lwuxlhed">General AI</Label>
          <div className="flex flex-1 items-center justify-center" data-id="element-254" data-mp="25tp3k4svenqy">
            <p className="text-[0.95cqw] text-[#4A5263]" data-id="element-255" data-mp="2asicdjx7pqks">No structure, no process</p>
          </div>
          <div className="flex items-center justify-between border border-white/15 px-[1cqw] py-[1.8cqh]" data-id="element-256" data-mp="2fs4p7s94p4t2">
            <span className="text-[1.05cqw] text-[#6B7588]" data-id="element-257" data-mp="2kqfzg43c5hbt">Ask anything</span>
            <span className="text-[0.9cqw] text-[#4A5263]" aria-hidden data-id="element-258" data-mp="1n48vmweuvt0i">
              ↵
            </span>
          </div>
        </div>

        <div className="flex flex-col border border-[#3B8CFF]/35 bg-[#3B8CFF]/[0.05] p-[1.8cqw]" data-id="element-259" data-mp="1s3bqxp51akva">
          <Label tone={INK.blue} data-id="element-260" data-mp="1x0c1ac8x29s7">DiligenceGPT™ · ready on day one, adapted to each firm</Label>
          <div className="mt-[2.6cqh] grid flex-1 grid-cols-3 gap-[2cqw]" data-id="element-261" data-mp="21u6fj05r5wjw">
            {groups.map((g, gi) => <Reveal key={g.name} delay={0.08 * gi} data-id="element-262" data-mp="14czdxzuxlxxu" data-mpi={gi}>
                <div className="h-px w-full" style={{
              background: g.tone
            }} data-id="element-263" data-mp="19bj0o2hcndr9" />
                <p className="mt-[1.4cqh] text-[0.8cqw] uppercase tracking-[0.2em]" style={{
              color: g.tone
            }} data-id="element-264" data-mp="11bcz7bui9eag">
                  {g.name}
                </p>
                <ul className="mt-[1.4cqh]" data-id="element-265" data-mp="wc9szo2sh20w">
                  {g.items.map(item => <li key={item} className="border-b border-white/8 py-[1.5cqh] text-[1.12cqw] text-[#E3E8F1]" data-id="element-266" data-mp="1b0wk0n1s3i7y">
                      {item}
                    </li>)}
                </ul>
              </Reveal>)}
          </div>
        </div>
      </div>
    </Slide>;
}